// extracted by mini-css-extract-plugin
export default {"block":"Loader_block__YLowC","loader":"Loader_loader__Y2m-Z","spinner":"Loader_spinner__NuE9K"};